import { AreaChart, BarChart } from "@tremor/react";
import FooterTransparent from "../../Components/Footer";
import Headers from "../../Components/HeaderPublic";
import CreateNewsLetter from '../CreateNewsLetter/CreateNewsLetter.jsx';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

function TerminoPage() {
  // Estilo CSS para forzar full width en header y footer
  const fullWidthStyle = {
    width: '100vw',
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    overflowX: 'hidden'
  };

  // Contenido estático de términos y condiciones
  const terminos = [
    {
      terminosCondiciones: `
        <div class="space-y-6">
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">1. Introducción</h2>
            <p>
              Estos términos y condiciones rigen el uso de la plataforma <strong>Industrial Business Clusters</strong> proporcionada por <strong>BAZAN OROZCO MARKETING CONSULTANTS</strong>. Al acceder y utilizar nuestra plataforma, aceptas cumplir con estos términos.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">2. Uso de la plataforma</h2>
            <ul class="list-disc pl-5 space-y-2">
              <li>
                <span class="font-semibold">Registro:</span> Para utilizar ciertos servicios, es posible que debas registrarte y proporcionar información personal veraz y actualizada.
              </li>
              <li>
                <span class="font-semibold">Conducta del Usuario:</span> Te comprometes a utilizar la plataforma de manera lícita y respetuosa. No debes usar la plataforma para actividades fraudulentas, ilegales o que infrinjan los derechos de terceros.
              </li>
              <li>
                <span class="font-semibold">Acoso:</span> Cualquier actividad de acoso a los usuarios de la plataforma será penalizada con la restricción del acceso a la misma. Y en caso de que estas actividades infrinjan las leyes locales, será reportado a las autoridades correspondientes.
              </li>
            </ul>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">3. Propiedad Intelectual</h2>
            <p>
              Todo el contenido en la plataforma, incluyendo textos, gráficos, logotipos y software, es propiedad de <strong>BAZAN OROZCO MARKETING CONSULTANTS</strong>, y está protegido por las leyes de propiedad intelectual. No puedes copiar, modificar, distribuir o utilizar dicho contenido sin nuestro permiso expreso.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">4. Limitación de Responsabilidad</h2>
            <p>
              <strong>BAZAN OROZCO MARKETING CONSULTANTS</strong> no se hace responsable de ningún daño directo, indirecto, incidental o consecuente que resulte del uso de nuestra plataforma. No garantizamos que el servicio será ininterrumpido o libre de errores fuera de la responsabilidad de la plataforma.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">5. Modificaciones de los Términos</h2>
            <p>
              Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en nuestra plataforma. Es tu responsabilidad revisar regularmente estos términos.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">6. Terminación</h2>
            <p>
              Podemos suspender o terminar tu acceso a la plataforma en cualquier momento, sin previo aviso, si creemos que has violado estos términos.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">7. Ley Aplicable</h2>
            <p>
              Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de los Estados Unidos Mexicanos. Cualquier disputa que surja en relación con estos términos se resolverá en los tribunales de la Ciudad de México.
            </p>
          </div>
          
          <div>
            <h2 class="text-xl font-bold text-blue-800 mb-2">8. Contacto</h2>
            <p class="mb-4">
              Si tienes alguna pregunta sobre estos términos y condiciones, contáctanos por correo.
            </p>
            
            <div class="bg-blue-800 text-white p-4 rounded-lg">
              <h3 class="text-lg text-left font-bold mb-2">Información de contacto</h3>
              <p class="text-left">BAZAN OROZCO MARKETING CONSULTANTS</p>
              <p class="text-left">Correo electrónico: no-reply@IndustrialBusinessClusters.com</p>
            </div>
          </div>
          
          <div class="text-right italic text-gray-500 mt-6">
            <p>Última actualización: 10 de marzo de 2025</p>
          </div>
        </div>
      `
    }
  ];

  return (
    <>
      {/* Header con ancho completo usando el estilo personalizado */}
      <div style={fullWidthStyle}>
        <Headers />
      </div>
      
      {/* Contenido principal centrado */}
      <div className="pb-16 pt-24 px-5 min-h-screen">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-center text-blue-800 mb-6">Términos y Condiciones</h1>
          <p className="text-center text-gray-600 mb-8">
            Por favor, lee cuidadosamente estos términos y condiciones antes de utilizar nuestra plataforma.
          </p>
          
          <div className="bg-white border rounded-lg shadow-md overflow-hidden">
            <div className="flex justify-center w-full tamanoConenedor scrollbar styleScrollbar">
              {terminos.map((item, index) => (
                <div key={index} className="w-full p-6 md:p-8">
                  <div 
                    className="text-gray-700 prose max-w-none text-justify" 
                    dangerouslySetInnerHTML={{ __html: item.terminosCondiciones }} 
                  />
                </div>
              ))}
            </div>
          </div>
          
          {/* Firma y Copyright */}
          <div className="text-center mt-8 text-gray-600">
            <p>&copy; 2025 Industrial Business Clusters - Todos los derechos reservados</p>
          </div>
        </div>
      </div>
      
      {/* Footer con ancho completo usando el estilo personalizado */}
      <div style={fullWidthStyle} className="-mb-8">
        <FooterTransparent />
      </div>
    </>
  );
}

export default TerminoPage;